import type { Airflow, Dict } from '@aviata/platform-types';
import dayjs from 'dayjs';
import { flightEntity } from 'freedom-shared';

import type { WatchlistOffer } from '../types';
import { mergeWatchlistDict } from './merge-watchlist-dict';

const nullPassengerRecord = {
  ADT: null,
  CHD: null,
  INF: null,
  YTH: null,
} as const;

function buildAirflowSegment(
  segment: WatchlistOffer['flights'][number]['segments'][number],
): Airflow.Segment.Entity {
  return {
    airline: segment.airline,
    display_airline: segment.airline,
    marketing_airline: segment.airline,
    flight_number: '',
    dep: {
      at: segment.dep.at,
      airport: segment.dep.airport,
      terminal: null,
    },
    arr: {
      at: segment.arr.at,
      airport: segment.arr.airport,
      terminal: null,
    },
    stops: { count: 0, locations: null },
    equipment: { code: null, name: null },
    cabin: { class: 'Economy', details: null },
    baggage: { free: { ...nullPassengerRecord }, recheck_required: false },
    hand_luggage: { free: { ...nullPassengerRecord } },
    connection: null,
    fare: { ...nullPassengerRecord },
  };
}

function buildAirflowFlight(
  flight: WatchlistOffer['flights'][number],
): Airflow.Offer.Flight {
  const segments = flight.segments.map(buildAirflowSegment);
  const firstDep = segments[0]?.dep.at;
  const lastArr = segments[segments.length - 1]?.arr.at;
  const durationSeconds =
    firstDep && lastArr ? dayjs(lastArr).diff(dayjs(firstDep), 'second') : 0;

  return {
    duration: durationSeconds,
    segments,
  };
}

export function mapWatchlistOfferToMappedFlights(
  dict: Partial<Dict.Entity> | undefined,
  offer: WatchlistOffer | null | undefined,
): flightEntity.types.MappedFlight[] {
  if (!offer?.flights?.length) return [];

  const merged = mergeWatchlistDict(dict, offer);

  return offer.flights.map(offerFlight =>
    flightEntity.lib.mapFlight(merged, buildAirflowFlight(offerFlight)),
  );
}
